import { Link } from "react-router-dom";
import { CONTACT_INFO, SERVICES } from "../data";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-dark text-white border-t border-slate-800">
      {/* Main Footer Content */}
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12">
          
          {/* Column 1: Brand & Presentation */}
          <div className="md:col-span-5 space-y-6">
            <Link to="/" className="flex items-center gap-3 group focus:outline-none">
              <div className="flex flex-col">
                <span className="text-base font-extrabold tracking-tight text-white leading-none">
                  Halsnæs
                </span>
                <span className="text-[10px] font-bold uppercase tracking-widest text-brand-orange mt-0.5">
                  Epoxygulve
                </span>
              </div>
            </Link>

            <p className="text-sm text-slate-300 leading-relaxed max-w-sm">
              Halsnæs Epoxygulve leverer fugefrie gulvløsninger af højeste kvalitet til erhverv, industri og private. Vi har fokus på slidstyrke, præcision og professionel rådgivning.
            </p>

            <div className="flex items-center gap-4 text-slate-300">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-teal text-lg text-brand-orange">
                <i className="fa-solid fa-award"></i>
              </span>
              <div>
                <p className="text-xs font-bold text-white uppercase tracking-wider">100% Kvalitetssikring</p>
                <p className="text-xs text-slate-400">Simon Babiel fører personligt tilsyn</p>
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="md:col-span-3 space-y-4">
            <h4 className="text-sm font-bold uppercase tracking-wider text-brand-orange">Hurtiglinks</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-slate-300 hover:text-brand-orange transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/flydemoertel" className="text-slate-300 hover:text-brand-orange transition-colors">
                  Flydemørtel
                </Link>
              </li>
              <li>
                <Link to="/kvartsgulve" className="text-slate-300 hover:text-brand-orange transition-colors">
                  Kvartsgulve
                </Link>
              </li>
              <li>
                <Link to="/epoxygulve" className="text-slate-300 hover:text-brand-orange transition-colors">
                  Epoxygulve
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-slate-300 hover:text-brand-orange transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Contact Info */}
          <div className="md:col-span-4 space-y-4">
            <h4 className="text-sm font-bold uppercase tracking-wider text-brand-orange">Kontaktoplysninger</h4>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-brand-orange mt-1"></i>
                <span>
                  <strong>Halsnæs Epoxygulve</strong>
                  <br />
                  {CONTACT_INFO.address}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-user text-brand-orange"></i>
                <span>Ejer: {CONTACT_INFO.owner}</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-brand-orange"></i>
                <a
                  href={`tel:+45${CONTACT_INFO.phone}`}
                  className="hover:text-brand-orange transition-colors whitespace-nowrap font-semibold"
                >
                  Tlf: {CONTACT_INFO.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-brand-orange"></i>
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  className="hover:text-brand-orange transition-colors whitespace-nowrap font-semibold break-all"
                >
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-file-invoice text-brand-orange"></i>
                <span>CVR-nr: {CONTACT_INFO.cvr}</span>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-zinc-950 border-t border-slate-800/60 py-6 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs text-slate-400">
          <p>© {currentYear} {CONTACT_INFO.company}. Alle rettigheder forbeholdes.</p>
          <p className="flex items-center gap-1">
            <span>Udført af professionelle gulvspecialister</span>
            <i className="fa-solid fa-circle text-[4px] text-brand-orange"></i>
            <span>Simon Babiel</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
